export { Cross } from './cross';



//////////////////
// WEBPACK FOOTER
// ./node_modules/@trustpilot/ecommscript-integrationappauth/dist/Assets/images/index.js
// module id = 1353
// module chunks = 0